import React from 'react'

// const markStrategy = (state, className) => {
//   const transform = state
//     .transform()
//     .collapseToStartOf(state.anchorBlock)
//     .extendToEndOf(state.anchorBlock);
//
//   const markToRemove = transform.state.marks.find(
//     ({ type }) => type === 'class',
//   );
//   markToRemove && transform.removeMark(markToRemove);
//   transform.addMark({
//     type: 'class',
//     data: { class: className },
//   });
//   return transform.focus().apply();
// };

const Node = ({ children, mark: { data } }) => (
  <div className={data.get('class')}>
    {children}
  </div>
)

const Plugin = () => ({
  schema: {
    marks: {
      class: Node,
    },
  },
})

export { Plugin as ClassPlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Class.js